import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Constant} from '../../../global/util/Constant';
import {ApplicationService} from '../../../user/service/application.service';
import {Dialog} from '../../../global/util/Dialog';
import {InformType} from '../../../global/util/enum/InformType';
import {TranslateService} from '@ngx-translate/core';
import {StringUtil} from '../../../global/util/StringUtil';
import {LocalStorage} from '../../../global/util/LocalStorage';

@Component({
  selector: 'app-confirmation-code',
  templateUrl: './confirmation-code.component.html',
  styleUrls: ['./confirmation-code.component.css']
})
export class ConfirmationCodeComponent implements OnInit, OnDestroy {
  verificationCodeForm: FormGroup;
  title: string;
  value: string;
  email: string;
  cellPhone: string;
  messageInfo: string;
  enabledBtn = true;
  showEmail: string;
  public loading: boolean;
  private uuid: any;
  isLogin: boolean;
  showTryAnotherWay = true;
  phoneNumberSplited = '';
  emailSplited = '';
  secondLeft = 0;
  enableBtn = true;
  sendOtpByEmail = false;
  private intervalCountDown: any;
  msgSendWhatsApp = '';
  username: any;

  constructor(private activeModal: NgbActiveModal,
              private builder: FormBuilder,
              private applicationService: ApplicationService,
              public translate: TranslateService) {
    this.createForm();
    this.getUUID();
  }

  ngOnInit(): void {
    const numbers = StringUtil.splitBy(this.email, 3);
    this.emailSplited = this.buildEmail();
    this.phoneNumberSplited = this.buildPhoneNumber();
    this.msgSendWhatsApp = this.translate.instant('MESSAGE.RECEIVE-OTP-VIA-WHATSAPP').replace('XXX', '<b>' + this.phoneNumberSplited + '</b>');
  }

  close() {
    this.activeModal.close();
  }

  private createForm() {
    this.verificationCodeForm = this.builder.group({
      codeVerification: ['', Validators.compose([
        Validators.pattern('^[0-9]{6}'),
        Validators.required
      ])]
    });
  }

  confirm() {
    this.loading = true;
    const code = this.verificationCodeForm.get('codeVerification').value;
    const url = Constant.ROOT_API_V1 + '/public/verify-verification-code?code='.concat(code).concat('&value=').concat(this.value);
    this.applicationService.get(url).subscribe((verification: any) => {
      this.loading = false;
      if (verification.validVerificationCode) {
        this.activeModal.close(verification.validVerificationCode);
      } else {
        this.enabledBtn = false;
        Dialog.show(InformType.Danger, this.translate.instant(this.title), this.translate.instant('MESSAGE.OPERATION-NOT-COMPLETED-BY-INCORRECT-CODE'));
      }
    }, error => {
      Dialog.show(InformType.Danger, this.translate.instant(this.title));
    });
  }

  public sendVerificationCode(): void {
    this.showTryAnotherWay = false;
    const url = Constant.ROOT_API_V1 + '/public/send-verification-code';
    const formData = new FormData();
    formData.append('uuid', this.uuid);
    formData.append('value', this.value);
    formData.append('email', this.email);
    formData.append('isLogin', String(this.isLogin));
    formData.append('isEmail', String(this.sendOtpByEmail));
    formData.append('username', String(this.username));
    // this.loading = true;
    this.applicationService.post(url, formData).subscribe((value: any) => {
      this.showTryAnotherWay = false;
      this.countDown();
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  sendVerificationEmail() {
    this.sendOtpByEmail = true;
    this.sendVerificationCode();
  }

  sendVerificationWsp() {
    this.sendOtpByEmail = false;
    this.sendVerificationCode();
  }

  tryAnotherWay() {
    this.showTryAnotherWay = true;
  }

  private getUUID(): void {
    const url = Constant.ROOT_API_V1 + '/public/uuid';
    this.applicationService.get(url).subscribe((value: any) => {
      this.uuid = value.uuid;
    }, error => {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.OBTAINING-UUID'));
    });
  }

  private buildEmail() {
    const numbers = StringUtil.splitBy(this.email, 10);
    return this.email.substring(0, 2) + '****************' + numbers[numbers.length - 1];
  }

  private buildPhoneNumber() {
    const numbers = StringUtil.splitBy(this.cellPhone, 3);
    return this.cellPhone.charAt(0) + this.cellPhone.charAt(1) + '*****' + numbers[numbers.length - 1];
  }

  validateFormat(event: any) {
    let key;
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      key = event.keyCode;
      key = String.fromCharCode(key);
    }
    const regex = /[0-9]|\./;
    if (!regex.test(key)) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
    }
  }

  /**
   * Activa la cuenta regresiva para solicitar el reenvío del código.
   * @private
   */
  private countDown() {
    this.enableBtn = true;
    LocalStorage.setItem('dateDown', Date.now().toString());
    this.intervalCountDown = setInterval(() => {
      const now = Date.now();
      const differenceTime = parseInt(LocalStorage.getDateDownLeft(), 10) * 50 * Constant.MILLISECONDS;
      this.secondLeft = this.getSecondsLeft(now, differenceTime, 50, Constant.MILLISECONDS);
      if (this.secondLeft <= 0) {
        this.stopCountdown();
      }
    }, 1000);
  }


  stopCountdown() {
    console.log('Stopping countdown...');
    clearInterval(this.intervalCountDown);
    this.enableBtn = false;
    this.secondLeft = 0;
  }

  getSecondsLeft(now: number, differenceTime: number, seconds: number, milliseconds: number) {
    return Math.floor(((differenceTime - now) % (milliseconds * seconds)) / milliseconds);
  }

  ngOnDestroy(): void {
    if (this.intervalCountDown) {
      clearInterval(this.intervalCountDown);
    }
  }

  resendCodeOtp() {
    this.loading = true;
    this.sendVerificationCode();
    this.enableBtn = true;
  }

  get isPresentPhoneNumber() {
    return this.cellPhone !== undefined && this.cellPhone !== null && this.cellPhone !== '';
  }
}
